import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowCorner = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 13L13 3M13 12.428L13 3L3.57198 3",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowCorner;
